import { Box, Typography, IconButton } from '@mui/material';
import React from 'react';
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ThumbUp from '@mui/icons-material/ThumbUp';
import ThumbDown from '@mui/icons-material/ThumbDown';
import FeedbackIcon from '@mui/icons-material/Feedback';
import Log from './log';


import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
// import TextareaAutosize from '@mui/material/TextareaAutosize';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {useLocation} from 'react-router-dom';


export default function Feedback(props) {
    const theme = useTheme()
    const sm = useMediaQuery(theme.breakpoints.down('md'))
    // const md = useMediaQuery(theme.breakpoints.up('md'))
    const lg = useMediaQuery(theme.breakpoints.up('lg'))
    // const [fbState, setFbState] = React.useState(0)
    const [open, setOpen] = React.useState(false);
    const [like, setLike] = React.useState(true);
    const [bug, setBug] = React.useState('');
    const [feature, setFeature] = React.useState('');
    const [email, setEmail] = React.useState('');
    const location = useLocation();
    const urlPathAndSearch = location.pathname + location.search;
  
    // const handleClickOpen = () => {
    //   setOpen(true);
    // };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    
    return (
        <Typography variant='subtitle' align='center' sx={{
            width:'100%', 
            color: theme.palette.mode === 'dark' ? '#CCCCFF' : '#6495ED' // Periwinkle for dark, Cornflower blue for light
        }}>
            <Box fontSize={sm ? "35%" : lg ? "60%" : "50%"} align='center'>
                <React.Fragment>
                    Like the app? 
                    <Box fontSize="50%" color='red' align='center' width='100%'>
                        <IconButton 
                            size='small' 
                            sx={{ 
                                color: theme.palette.mode === 'dark' ? '#CCCCFF' : '#6495ED' // Periwinkle for dark, Cornflower blue for light
                            }}
                            onClick={() => {setOpen(true); setLike(true); /*setTimeout(() => setFbState(2), 20000);*/ Log.log('Feedback: Like - at page ' + urlPathAndSearch)}}>
                            <ThumbUp fontSize='inherit'/>
                        </IconButton>
                        <IconButton 
                            size='small' 
                            sx={{ 
                                color: theme.palette.mode === 'dark' ? '#CCCCFF' : '#6495ED' // Periwinkle for dark, Cornflower blue for light
                            }}
                            onClick={() => {setOpen(true); setLike(false); /*setTimeout(() => setFbState(2), 20000); */ Log.log('Feedback: Dislike - at page ' + urlPathAndSearch)}}>
                            <ThumbDown fontSize='inherit'/>
                        </IconButton>
                    </Box>
                    <Dialog open={open} onClose={handleClose} fullWidth={true}>
                        <DialogTitle>Feedback</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {like 
                                ? 'Glad you liked our App. Tell us more.'
                                : 'Thank you very much. We would love to get more details.'
                            }<br/>
                        </DialogContentText>
                    </DialogContent>
                    { like ? 
                            <DialogContent>
                                <TextField autoFocus color='info' margin="dense" minRows={3} id="bug" multiline
                                label="What did you like" fullWidth onChange={(e) => setBug(e.target.value)}
                                />
                                <TextField color='info' margin="dense" minRows={3} id="feature" multiline
                                label="What would you like for us to improve on" fullWidth onChange={(e) => setFeature(e.target.value)}
                                />
                                <TextField margin="dense" id="name" color='info'
                                label="Email Address" type="email" fullWidth onChange={(e) => setEmail(e.target.value)}
                                />
                            </DialogContent>
                        : 
                            <DialogContent>
                                <TextField autoFocus color='info' margin="dense" minRows={3} id="bug" multiline
                                label="Report issue" fullWidth onChange={(e) => setBug(e.target.value)}
                                />
                                <TextField color='info' margin="dense" minRows={3} id="feature" multiline
                                label="Request feature" fullWidth onChange={(e) => setFeature(e.target.value)}
                                />
                                <TextField margin="dense" id="name" color='info'
                                label="Email Address" type="email" fullWidth onChange={(e) => setEmail(e.target.value)}
                                />
                            </DialogContent>
                    }
                    <DialogActions align='center'>
                        <Button size="small" onClick={handleClose} color='info'>Cancel</Button>
                        { like ? 
                          <Button size="small"  onClick={() => {Log.log('Feedback: Like - at page ' + urlPathAndSearch + '. Bug ' + bug + '. Improve - ' + feature + '. Email - ' + email); handleClose()}} color='success'>Send</Button>
                            : <Button size="small"  onClick={() => {Log.log('Feedback: Dislike - at page ' + urlPathAndSearch + '. Bug - ' + bug + '. Feature - ' + feature + '. Email - ' + email); handleClose()}} color='success'>Send</Button>
                        }
                    </DialogActions>
                    </Dialog>
                </React.Fragment>
            </Box>
        </Typography> 
    )
}

export function FeedbackFormDialog() {
    const [open, setOpen] = React.useState(false);
    const [bug, setBug] = React.useState('');
    const [feature, setFeature] = React.useState('');
    const [email, setEmail] = React.useState('');
  
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    return (
      <Box>
        Thank you! We would love to hear more. <br/>Click here 
        <IconButton size='small' variant="outlined" color="info" onClick={handleClickOpen} p={0}>
          <FeedbackIcon/>
        </IconButton>
        <Dialog open={open} onClose={handleClose} fullWidth={true}>
          <DialogTitle>Feedback</DialogTitle>
          <DialogContent>
            <TextField autoFocus color='secondary' margin="dense" minRows={3} id="bug" multiline
              label="Report issue" fullWidth onChange={(e) => setBug(e.target.value)}
            />
            <TextField color='secondary' margin="dense" minRows={3} id="feature" multiline
              label="Request feature" fullWidth onChange={(e) => setFeature(e.target.value)}
            />
            <TextField margin="dense" id="name" color='secondary'
              label="Email Address" type="email" fullWidth onChange={(e) => setEmail(e.target.value)}
            />
          </DialogContent>
          <DialogActions align='center'>
            <Button size="small" onClick={handleClose} color='error'>Cancel</Button>
            <Button size="small"  onClick={() => {Log.log('Feedback: Bug - ' + bug + ' Feature - ' + feature + ' Email - ' + email); handleClose()}} color='success'>Send</Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }


//   export default function Feedback(props) {
//     const theme = useTheme()
//     const sm = useMediaQuery(theme.breakpoints.down('md'))
//     const md = useMediaQuery(theme.breakpoints.up('md'))
//     const lg = useMediaQuery(theme.breakpoints.up('lg'))
//     const [fbState, setFbState] = React.useState(0)
    
//     return (
//         <Typography variant='subtitle' align='center' sx={{width:'100%', color: 'white'}}>
//             <Box fontSize={sm ? "35%" : lg ? "60%" : "50%"} align='center'>
//                 {fbState == 0 ? 
//                     <React.Fragment>
//                         Like the app? 
//                         <Box fontSize="50%" color='red' align='center' width='100%'>
//                             <IconButton size='small' color='success' onClick={() => {setFbState(1); /*setTimeout(() => setFbState(2), 20000);*/ Log.log('Feedback: Like')}}><ThumbUp fontSize='inherit'/></IconButton>
//                             <IconButton size='small' color='error' onClick={() => {setFbState(1); /*setTimeout(() => setFbState(2), 20000); */ Log.log('Feedback: Dislike')}}><ThumbDown fontSize='inherit'/></IconButton>
//                         </Box>
//                     </React.Fragment>
//                 : fbState == 1 ? 
//                     <FeedbackFormDialog />
//                     // <React.Fragment>
//                     //     Thank you for your feedback
//                     // </React.Fragment>
//                     : ''
//                 }
//             </Box>
//         </Typography> 
//     )
// }

// export function FeedbackFormDialog() {
//     const [open, setOpen] = React.useState(false);
//     const [bug, setBug] = React.useState('');
//     const [feature, setFeature] = React.useState('');
//     const [email, setEmail] = React.useState('');
  
//     const handleClickOpen = () => {
//       setOpen(true);
//     };
  
//     const handleClose = () => {
//       setOpen(false);
//     };
  
//     return (
//       <Box>
//         Thank you! We would love to hear more. <br/>Click here 
//         <IconButton size='small' variant="outlined" color="info" onClick={handleClickOpen} p={0}>
//           <FeedbackIcon/>
//         </IconButton>
//         <Dialog open={open} onClose={handleClose} fullWidth={true}>
//           <DialogTitle>Feedback</DialogTitle>
//           <DialogContent>
//             <TextField autoFocus color='secondary' autoFocus margin="dense" minRows={3} id="bug" multiline
//               label="Report issue" fullWidth onChange={(e) => setBug(e.target.value)}
//             />
//             <TextField color='secondary' margin="dense" minRows={3} id="feature" multiline
//               label="Request feature" fullWidth onChange={(e) => setFeature(e.target.value)}
//             />
//             <TextField margin="dense" id="name" color='secondary'
//               label="Email Address" type="email" fullWidth onChange={(e) => setEmail(e.target.value)}
//             />
//           </DialogContent>
//           <DialogActions align='center'>
//             <Button size="small" onClick={handleClose} color='error'>Cancel</Button>
//             <Button size="small"  onClick={() => {Log.log('Feedback: Bug - ' + bug + ' Feature - ' + feature + ' Email - ' + email); handleClose()}} color='success'>Send</Button>
//           </DialogActions>
//         </Dialog>
//       </Box>
//     );
//   }